import React from "react"
import tw, { styled, css } from "twin.macro"
import PhoneInput, { CountryData } from "react-phone-input-2"
import { ReactComponent as SpinnerSvg } from "../../assets/icons/spinner.svg"

const StyledSpinner = styled(SpinnerSvg)(() => [tw`absolute right-3.5 top-10 animate-spin h-3.5 w-3.5`])
const StyledPhoneInput = styled.div(() => [
  tw` space-y-2 max-w-screen-mobile-lg`,
  css`
    .phoneInput {
      ${tw`!h-[42px]`} font-family: Jeko !important;
    }
    .inputFull {
      ${tw`!w-full`}
    }
    .react-tel-input .phoneInput,
    .flag-dropdown {
      ${tw`!text-base`} font-family: Jeko !important;
    }
  `,
])

interface PhoneInputProps {
  label?: string
  inputValue: string
  handleChange: (phone: string, country: unknown | CountryData) => void
  error: string | undefined
  autoFocus?: boolean
  handleFocus?: () => void
  loading?: boolean
}
export const PhoneNumberInput = (props: PhoneInputProps) => {
  const { label, inputValue, handleChange, error, autoFocus, handleFocus, loading } = props
  return (
    <StyledPhoneInput>
      <label tw="text-md text-body-color font-bold">{label}</label>
      <PhoneInput
        country={"us"}
        value={inputValue}
        onChange={(phone, country) => handleChange(phone, country)}
        inputProps={{ name: "phone", required: true, autoFocus: !!autoFocus, "data-testid": "phoneNum-input" }}
        inputClass={"phoneInput inputFull"}
        onFocus={handleFocus}
      />
      {loading && <StyledSpinner data-testid="spinner" />}
      <p tw="min-h-[18px] text-xs text-base-3 font-bold" css={error && tw`text-red`}>
        {error}
      </p>
    </StyledPhoneInput>
  )
}
